// extracted by mini-css-extract-plugin
module.exports = {"list":"PaymentTotals_list__TZutx","row":"PaymentTotals_row__XMa_l","values":"PaymentTotals_values__Dlkw_"};